module.exports = __webpack_public_path__ + "static/img/four_07.8e8d9f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_07.png
// module id = rxkJ
// module chunks = 3